<div class="map">
  <div>
    <button mat-icon-button class="btn-close" (click)="close()"><mat-icon>close</mat-icon></button>
    <button mat-icon-button class="btn-default" (click)="savePoly()"><mat-icon>save</mat-icon></button>
    <button mat-icon-button class="btn-default" id="delete-button" (click)="resetMap()"><mat-icon>refresh</mat-icon></button>
    <h2>Mark the hole location and draw the boundaries</h2>
  </div>
  <agm-map [latitude]="latitude" [longitude]="longitude" [zoom]="zoom" [fullscreenControl]="fullscreenControl"
  [mapTypeId]="mapTypeId" (mapReady)="onMapReady($event)" id="map">
  </agm-map>
</div>
